import classNames from 'classnames';
import React from 'react';

interface Props {
	selected: number;
	onClick: (value: any, selected: number) => void;
	value: any;
	disabled?: boolean;
}

//https://brandlive-upload.s3-us-west-2.amazonaws.com/uploads/17/documents/344igkb2i7/Screen_Shot_2020-11-02_at_9.01.05_AM.png
export default function PillToggle(props: Props): JSX.Element{
	const { selected, onClick, value, disabled = false } = props;
	return (
		<div className={classNames('pill-toggle', { disabled })}>
			<button
				className={selected === 1 ? 'selected' : ''}
				onClick={() => onClick(value, 1)}
			>
				Required
			</button>
			<button
				className={selected === 0 ? 'selected' : ''}
				onClick={() => props.onClick(value, 0)}
			>
				Optional
			</button>
		</div>
	);
}